module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800-d7955b20019bd6fe80920721374fc6d8.webp";